import { render, staticRenderFns } from "./ImportedCredentialsAdmin.vue?vue&type=template&id=072b134b&scoped=true"
import script from "./ImportedCredentialsAdmin.vue?vue&type=script&lang=js"
export * from "./ImportedCredentialsAdmin.vue?vue&type=script&lang=js"
import style0 from "./ImportedCredentialsAdmin.vue?vue&type=style&index=0&id=072b134b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b134b",
  null
  
)

export default component.exports